// extracted by mini-css-extract-plugin
export default {"title":"iQpo41nrqV7m0gUYJ3Dw","border":"GP3ySJpqzYtC0S8QaAim"};